var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32 2.966h19.452a1 1 0 0 1 .855 1.517L12.9 20.552a1 1 0 0 1-1.711 0L1.465 4.483a1 1 0 0 1 .855-1.517",
    className: "down_svg__cls1"
  })));
};
export { SvgDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjQgMjQiPgogICAgIDx0aXRsZT5hcnJvdy1idXR0b24tZG93bi0yPC90aXRsZT4KICAgIDxwYXRoIGNsYXNzPSJjbHMxIiBkPSJNMi4zMiwyLjk2NkgyMS43NzJhMSwxLDAsMCwxLC44NTUsMS41MTdMMTIuOSwyMC41NTJhMSwxLDAsMCwxLTEuNzExLDBMMS40NjUsNC40ODNBMSwxLDAsMCwxLDIuMzIsMi45NjZaIi8+Cjwvc3ZnPg==";